import api from './api';
import type {
  ClaimRequestAdmin,
  DirectoryCompany,
  DirectoryCompanyDetail,
  DirectoryMatch,
  PaginatedResponse,
} from '../types';

export const directoryApi = {
  /** GET /api/directory/ — paginated list. */
  list(params?: { page?: string; search?: string; state?: string; status?: string }) {
    return api.get<PaginatedResponse<DirectoryCompany>>('/directory/', { params })
      .then((r) => r.data);
  },

  /** GET /api/directory/:slug/ — unclaimed company detail. */
  detail(slug: string) {
    return api.get<DirectoryCompanyDetail>(`/directory/${slug}/`).then((r) => r.data);
  },

  /** POST /api/claim-requests/ — submit a claim form. */
  submitClaim(body: {
    slug: string;
    claimant_name: string;
    claimant_email: string;
    claimant_title?: string;
    justification?: string;
  }) {
    return api.post('/claim-requests/', body);
  },

  /** GET /api/signup/match-directory/ — find matching directory entries. */
  matchDirectory(params: { name: string; city: string; state: string }) {
    return api.get<{ matches: DirectoryMatch[] }>('/signup/match-directory/', { params })
      .then((r) => r.data);
  },

  /** POST /api/activate/ — claimant sets password. */
  activate(body: { token: string; password: string }) {
    return api.post<{ email: string }>('/activate/', body).then((r) => r.data);
  },

  /** Admin claim queue + actions. */
  adminListClaims(params?: { page?: string; status?: string }) {
    return api.get<PaginatedResponse<ClaimRequestAdmin>>(
      '/admin-panel/claim-requests/', { params },
    ).then((r) => r.data);
  },
  adminGetClaim(id: string) {
    return api.get<ClaimRequestAdmin>(
      `/admin-panel/claim-requests/${id}/`,
    ).then((r) => r.data);
  },
  adminApproveClaim(id: string, admin_notes?: string) {
    return api.post(`/admin-panel/claim-requests/${id}/approve/`, { admin_notes });
  },
  adminDenyClaim(id: string, admin_notes: string) {
    return api.post(`/admin-panel/claim-requests/${id}/deny/`, { admin_notes });
  },
  adminRequestInfoClaim(id: string, admin_notes: string) {
    return api.post(`/admin-panel/claim-requests/${id}/request-info/`, { admin_notes });
  },
  adminSetupOrgForClaim(id: string, body?: { org_name?: string }) {
    return api.post(`/admin-panel/claim-requests/${id}/setup-org/`, body || {});
  },
};
